/* Switch */
const handleToggle = (val) => {
  document.getElementsByClassName("product-area__switch-button")[val].classList.remove("selected__switch-button")
  if (val == 0) document.getElementsByClassName("product-area__switch-toggle")[0].style.left = '50%'
  else document.getElementsByClassName("product-area__switch-toggle")[0].style.left = '-1px'
}

const initImages = (imgs) => {
  imgs.style.opacity = '0'
  imgs.style.position = 'absolute'
  imgs.style.width = "100%"
}

const showImages = (imgs) => {
  handleToggle(0)
  imgs.style.position = 'static'
  imgs.style.opacity = '1'
  imgs.style.display = 'block'
  panel.style.display = 'none'
}

const showPanel = (imgs) => {
  handleToggle(1)
  initImages(imgs)
  panel.style.display = 'block'
}

var images = document.getElementById("product-image-slider")
var panel = document.getElementById("product-area__panel")
var panel_switch = document.querySelector('.product-area__switch')

if (window.innerWidth > 768) {
  initImages(images)
}
else {
  handleToggle(0)
  panel.style.display = 'none'
  images.style.zIndex = '0'
}

window.addEventListener('resize', () => {
  if (window.innerWidth <= 768) {
    showImages(images)
    document.getElementsByClassName("product-area__switch-button")[1].classList.add("selected__switch-button")
  }
  else {
    showPanel(images)
    document.getElementsByClassName("product-area__switch-button")[0].classList.add("selected__switch-button")
    dropdownPanel.style.display = 'none'
  }
})

document.querySelectorAll('.product-area__switch-button').forEach(item => {
  item.addEventListener('click', (e) => {
    item.classList.add("selected__switch-button")
    if (item.textContent === "Product Images") {
      showImages(images)
    }
    else {
      showPanel(images)
    }
  })
})

/* Panel Scroll */
const scrollTo = (ref) => window.scrollTo({left: 0, top: ref, behavior: 'smooth'})

/* Mini Panel Bar and Summary Bar Scroll Event*/
var landingHeight = document.querySelector('.product-area').offsetTop
var navHeight = (document.querySelector('.site-control').offsetHeight-1) + "px"
window.addEventListener('resize', () => {
  navHeight = (document.querySelector('.site-control').offsetHeight-1) + "px"
})
var prevScrollpos = window.pageYOffset
var miniPanel = document.querySelector('.product-area__mini-panel')
// var summaryBar = document.querySelector('.product-area__summary-bar')
var dropdownPanel = document.querySelector('.product-area__mini-panel__dropdown')

window.onscroll = () => {
  var currentScrollPos = window.pageYOffset
  if (currentScrollPos <= (landingHeight + 40)) {
    miniPanel.style.top = '-550px'
    // summaryBar.style.bottm = '-80px'
  }
  else if (prevScrollpos > currentScrollPos) {
    miniPanel.style.top = navHeight
    // summaryBar.style.bottm = '0px'
  }
  else {
    miniPanel.style.top = '-1px'
    // summaryBar.style.bottm = '0px'
  }
  prevScrollpos = currentScrollPos
}

/* Mini Panel Bar Click Event*/
var allComponents = document.querySelector('.product-area__mini-panel__main')
allComponents.addEventListener('click', (e) => {
  if (dropdownPanel.style.display == 'none') {
    dropdownPanel.style.display = 'flex'
    dropdownPanel.style.flexDirection = 'column'
  } else {
    dropdownPanel.style.display = 'none'
  }
})
document.addEventListener('click', (e) => {
  if (!e.target.closest(".product-area__mini-panel")) {
    dropdownPanel.style.display = 'none'
  }
})